/* global FormData */
import React from 'react'
import { classToDOMCard } from 'react-mobiledoc-editor'
import Icon from '../../Icon'
import utils from '../../../lib/utils'
import api from '../../../api'
// import imagePart from '../../../parts/image'

// const imageSchema = imagePart.schema({
//   file_limit: 1,
//   publicUrl: true
// })
// const ImageComponent = imageSchema.component({})

class Image extends React.Component {
  static displayName = 'Image'

  onFileChange = e => {
    e.preventDefault()
    this.uploadFile(e.currentTarget.files[0])
    e.currentTarget.value = ''
  }

  uploadFile = file => {
    const data = new FormData()
    data.append('file', file)
    // const upload = await api.post('content/upload', false, {
    //   site: utils.getSite(),
    //   public: true,
    //   body: data
    // })

    // this.onSave({src: upload.url})
    api.post('content/upload', false, {
      site: utils.getSite(),
      public: true,
      forWeb: true,
      body: data
    }).then(upload => {
      this.onSave({src: upload.url})
    })
  }

  onSave = (value) => {
    this.props.save(value)
  }

  onCancel = () => {
    const {payload} = this.props

    if (!payload.src) {
      this.props.remove()
    } else {
      this.props.cancel()
    }
  }

  render () {
    const {payload, edit, isEditing} = this.props

    if (isEditing) {
      return <div className='panel file-picker'>
        <label className='file-upload'>
          <input type='file' onChange={this.onFileChange} />
          <span className='file-upload-label'>
            <Icon name='ios-cloud-upload' /> Pick an image
          </span>
        </label>
        <a role='button' onClick={this.onCancel}>Cancel</a>
      </div>
    }

    return <div>
      <img src={payload.src} onClick={edit} />
    </div>
  }
}

export default classToDOMCard(Image)



// WEBPACK FOOTER //
// ./app/components/editor/cards/Image.js